import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { UrgencyBar } from './UrgencyBar';
export const Header = () => {
  return <header className="bg-black text-bttf-text border-b border-bttf-accent/30 z-50 sticky top-0" data-id="element-154">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-155">
        <div className="flex items-center space-x-2" data-id="element-156">
          <BookOpenIcon className="h-6 w-6 text-bttf-accent shadow-neon-blue" data-id="element-157" />
          <span className="font-bold text-lg bg-gradient-main text-transparent bg-clip-text" data-id="element-158">
            BTTF 40th Anniversary
          </span>
        </div>
        <nav data-id="element-159">
          <ul className="flex space-x-3 md:space-x-6 items-center" data-id="element-160">
            <li className="hidden md:block" data-id="element-161">
              <a href="#book" className="text-bttf-text hover:text-bttf-accent transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-bttf-accent after:transition-all" data-id="element-162">
                The Book
              </a>
            </li>
            <li className="hidden md:block" data-id="element-163">
              <a href="#pricing" className="text-bttf-text hover:text-bttf-accent transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-bttf-accent after:transition-all" data-id="element-164">
                Editions
              </a>
            </li>
            <li data-id="element-165">
              <a href="#pricing" className="bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text font-bold px-3 py-2 sm:px-4 sm:py-2 rounded-md transition-colors shadow-md hover:shadow-neon-orange text-sm sm:text-base whitespace-nowrap" data-id="element-166">
                Get My Copy
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <UrgencyBar data-id="element-167" />
    </header>;
};